import translation from 'locales/translation';
import { ToastTypes } from 'plataforma-fundacao-componentes';
import { Dispatch } from 'react';
import { getAccountsToConfirm } from 'services/assessor';
import { IProps } from './ConfirmarPresencaReducer';

export const CONFIRM_PRESENCE_LIST = 'CONFIRM_PRESENCE_LIST';
export const CONFIRM_PRESENCE_SET = 'CONFIRM_PRESENCE_SET';
export const CONFIRM_PRESENCE_LOAD = 'CONFIRM_PRESENCE_LOAD';
export const CONFIRM_PRESENCE_BY_CPF = 'CONFIRM_PRESENCE_BY_CPF';
export const CONFIRM_PRESENCE_EVENT_ID = 'CONFIRM_PRESENCE_EVENT_ID';
export const CONFIRM_PRESENCE_CHANGE_INPUT = 'CONFIRM_PRESENCE_CHANGE_INPUT';
export const CONFIRM_PRESENCE_ALL_PRESENT = 'CONFIRM_PRESENCE_ALL_PRESENT';
export const CONFIRM_PRESENCE_SET_METADADOS = 'CONFIRM_PRESENCE_SET_METADADOS';
export const COMPUTE_VOTES_PRESENCE_VOTES = 'COMPUTE_VOTES_PRESENCE_VOTES';

export const loadAccount = (
  showToast: any,
  state: IProps,
  dispatch: Dispatch<any>
) => {
  dispatch({ type: CONFIRM_PRESENCE_LOAD, payload: true });

  return getAccountsToConfirm(
    state.eventId,
    state.filter.value.trim(),
    state.filter.isSearchByCpf
  )
    .then(({ data }) => {
      dispatch({
        type: CONFIRM_PRESENCE_LIST,
        payload: data,
      });
    })
    .catch(() => {
      showToast({
        pauseOnFocusLoss: true,
        theme: ToastTypes.Error,
        showStatusBar: true,
        timeout: 4000,
        label: translation.ConfirmarPresencaModal.errLoadAccount,
      });
    })
    .finally(() => {
      dispatch({ type: CONFIRM_PRESENCE_LOAD, payload: false });
    });
};
